module.exports = __webpack_public_path__ + "img/shield_white.8f2cce85.svg";